// Ports of webapp/src/user.tsx, blocks/team.ts, blocks/sharing.ts,
// store/clientConfig.ts and config/clientConfig.ts.

export interface IUser {
    id: string
    username: string
    email: string
    nickname: string
    firstname: string
    lastname: string
    props: Record<string, any>
    create_at: number
    update_at: number
    is_bot: boolean
    is_guest: boolean
    permissions?: string[]
    roles: string
}

export interface ITeam {
    readonly id: string
    readonly title: string
    readonly signupToken: string
    readonly settings: Readonly<Record<string, any>>
    readonly modifiedBy?: string
    readonly updateAt?: number
}

export interface ISharing {
    id: string
    enabled: boolean
    token: string
    modifiedBy?: string
    updateAt?: number
}

export const ShowUsername = 0
export const ShowNickname = 1
export const ShowFullName = 2

export interface ClientConfig {
    telemetry: boolean
    telemetryid: string
    enablePublicSharedBoards: boolean
    teammateNameDisplay: number
    featureFlags: Record<string, boolean>
    maxFileSize: number
}

export const defaultClientConfig: ClientConfig = {
    telemetry: false,
    telemetryid: '',
    enablePublicSharedBoards: false,
    teammateNameDisplay: ShowUsername,
    featureFlags: {},
    maxFileSize: 0,
}

export interface ILimits {
    cardLimit: number
    cardCount: number
    archivePollInterval: number
    blockLimit: number
    blockCount: number
}

export interface UserPrefs {
    theme?: string
    collapseSidebar?: boolean
    nameFormat?: string
}
